import { CommonConfig } from '../configs/config.common';
import { AxiosPromise } from './axios.promise';

export async function createLead(myform: ILeadCreateForm) {
    console.log(myform);
    const config = new CommonConfig();
    const res = await AxiosPromise.postJson(
        config.createLeadUrl,
        myform
    );
    console.log(res);
}

export function getSourceChannel(locale: any) {
    return locale === 'en' ? 'rifo-en' : 'rifo-cn';
}

export interface ILeadCreateForm {
    leadName: string;
    clientName: string;
    email: string;
    phone: string;
    agentRefer?: string;
    street?: string;
    zip?: string;
    city?: string;
    registerAccount: boolean;
    channel: string;
    yonghuId?: number;
    mysource?: string;
    clientMsg?: string;
}
